enum NetworkAssessmentAnalysisType {
  Unknown = "unknown",
  ServiceArea = "serviceArea",
  Opportunity = "opportunity",
  TermedServiceArea = "termedServiceArea",
  TermedOpportunity = "termedOpportunity",
  ProjectedServiceArea = "projectedServiceArea",
  ProjectedOpportunity = "projectedOpportunity",
  ProjectedTermedServiceArea = "projectedTermedServiceArea",
  ProjectedTermedOpportunity = "projectedTermedOpportunity",
}

enum AdequacyType {
  MedicareAdvantage = 1,
  CCIIOQHP = 2,
  NYSDOH = 3,
  PACAID = 4,
  CACDI = 5,
  CADMHC = 6,
  NJDOBI = 7,
  NPI = 8,
  ILCAID = 9,
  TXCAID = 10,
  NMCAID = 11,
  NJDMAHS = 12,
}

enum FilterType {
  Band = "/band/",
  County = "/county/",
  Inspection = "/inspection/",
  Specialty = "/specialty/",
  State = "/state/",
  Zip = "/zip/",
}

enum CalculationMethod {
  Distance = 0,
  Time = 1,
  TimeAndDistance = 2,
  TimeOrDistance = 3,
}

enum ProjectExclusionType {
  /**
   * Provider is not excluded
   */
  None = "none",

  /**
   * Facility is excluded due to Deactivated NPI.  Marty says this enum value may not remain - a single DeactivatedNPI enum value is probably sufficient
   */
  DeactivatedFacility = "deactivatedFacility",

  /**
   * Provider is excluded due to Deactivated NPI
   */
  DeactivatedProvider = "deactivatedProvider",

  /**
   * Provider is excluded due to Medicare Opt-Out
   */
  MedicareOptOut = "medicareOptOut",

  /**
   * Provider is excluded due to OIG Exclusion
   */
  OIGExclusion = "oigExclusion",

  /**
   * Specifies that a provider has an OIG Exclusion waiver
   */
  OIGExclusionWaiver = "oigExclusionWaiver",

  /**
   * Provider is precluded from receiving payment.
   */
  Precluded = "precluded",

  /**
   * Facility is excluded due to invalid NPPES NPIs
   */
  InvalidNppesNpiFacility = "invalidNppesNpiFacility",

  /**
 * Provider is excluded due to invalid NPPES NPIs
 */
  InvalidNppesNpiProvider = "invalidNppesNpiProvider",

  /**
   * Facility is excluded due to missing NPIs
   */
  MissingNpiFacility = "missingNpiFacility",

  /**
 * Provider is excluded due to missing NPIs
 */
  MissingNpiProvider = "missingNpiProvider",
}

enum ImpactIndicator {
  None = "none",
  EmptyDot = "emptyDot",
  FullDot = "fullDot",
}

enum NextClosestProviderAction {
  Unknown = "unknown",
  None = "none",
  FilterToNextClosestProvidersOnly = "filterToNextClosestProvidersOnly",
  AppendNextClosestProviders = "appendNextClosestProviders",
}

enum NPIStatus {
  Unknown = "unknown",
  Valid = "valid",
  Deactivated = "deactivated",
  Invalid = "invalid",
  Missing = "missing",
}

enum ProjectionProviderType {
  Unknown = "unknown",
  Target = "target",
  ExcludeImpact = "excludeImpact",
}

enum ProjectionProviderHistoryType {
  Unknown = "unknown",
  Created = "created",
  Cloned = "cloned",
  Standard = "standard",
}

enum ProjectPerspective {
  All = "ALL",
  ByCounty = "BY_COUNTY",
  BySpecialty = "BY_SPECIALTY",
  ByState = "BY_STATE",
  ByInspection = "BY_INSPECTION",
  ByZipCode = "BY_ZIP_CODE",
  ByZipClass = "BY_ZIP_CLASS",
}

enum ProjectRunConfigurationStatus {
  Unknown = "unknown",
  Created = "created",
  Queued = "queued",
  Analyzing = "analyzing",
  Aggregating = "aggregating",
  Succeeded = "succeeded",
  Failed = "failed",
  Canceled = "canceled",
  QueuedProviderChanges = "queuedProviderChanges",
  ProcessingProviderChanges = "processingProviderChanges",
  QueuedSpecialtyGroupExceptionAnalysis = "queuedSpecialtyGroupExceptionAnalysis",
  ProcessingSpecialtyGroupExceptionAnalysis = "processingSpecialtyGroupExceptionAnalysis",
  FailedProviderChanges = "failedProviderChanges",
  QueuedNetworkNcp = "queuedNetworkNcp",
  ProcessingNetworkNcp = "processingNetworkNcp",
  FailedNetworkNcp = "failedNetworkNcp",
  CanceledNetworkNcp = "canceledNetworkNcp",
  QueuedProspectMarketNcp = "queuedProspectMarketNcp",
  ProcessingProspectMarketNcp = "processingProspectMarketNcp",
  FailedProspectMarketNcp = "failedProspectMarketNcp",
  CanceledProspectMarketNcp = "canceledProspectMarketNcp",
}

// this is a newer enum for the separate ProjectRunConfigurationStatus table,
// first used for zip analysis projects
enum ProjectRunStatusEnum {
  Unknown = "unknown",
  Created = "created",
  Queued = "queued",
  Running = "running",
  // 4 is blank for backwards compatibility
  Succeeded = "succeeded",
  Failed = "failed",
  Canceled = "canceled",
}

enum AccuracyGapAnalysisStatus {
  Unknown = "unknown",
  Queued = "queued",
  Analyzing = "analyzing",
  Succeeded = "succeeded",
  Failed = "failed",
  Canceled = "canceled",
}

enum ProjectRunConfigurationType {
  Unknown = "unknown",
  Standard = "standard",
  DualMembershipPrimary = "dualMembershipPrimary",
  DualMembershipSupplemental = "dualMembershipSupplemental",
}

enum ProjectRunConfigurationJobStatus {
  Unknown = "unknown",
  Queued = "queued",
  Processing = "processing",
  Loaded = "loaded",
  Purged = "purged",
  Failed = "failed",
}

enum ProviderNetworkType {
  Unknown = "unknown",
  Network = "network",
  Prospect = "prospect",
  Market = "market",
  NetNew = "netNew"
}

enum RegionSetStatusType {
  Active = "Active",
  Approved = "Approved",
  Opportunity = "Opportunity",
  Pending = "Pending",
  Unknown = "Unknown",
}

enum ComparisonProviderType {
  Unknown = "Unknown",
  Added = "Added",
  Removed = "Removed",
  Matched = "Matched",
}

enum TimeFrequency {
  Unknown = "unknown",
  All = "all",
  Monthly = "monthly",
}

enum AttestationRateDays {
  Ninety = "90",
  ThreeSixtyFive = "365"
}

enum TimeDistanceCalculatorType {
  Unknown = "unknown",
  Quest = "quest",
  GeographyAware = "geographyAware",
  GraphhopperRouting = "graphhopperRouting",
  StraightLine = "straightLine",
}

enum AccuracyInspectionResultTypeEnum {
  Unknown = "Unknown",
  Name = "Name",
  Address = "Address",
  Phone = "Phone",
}

enum AccuracySupplementalTypeEnum {
  Valid = "valid",
  Unknown = "unknown",
  Enriched = "enriched",
  Invalid = "invalid",
}

enum PanelStatusEnum {
  Unknown = "unknown",
  AcceptingNewPatients = "acceptingNewPatients",
  NotAcceptingNewPatients = "notAcceptingNewPatients",
  SeeingEstablishedPatientsOnly = "seeingEstablishedPatientsOnly",
  PatientAgeRestriction = "patientAgeRestriction",
}

enum RecommendedActionTypeEnum {
  Unknown = "Unknown",
  Suppress = "Suppress",
  Investigate = "Investigate",
  Update = "Update",
  Retain = "Retain",
  Standardize = "Standardize",
  Enrich = "Enrich",
  Supplement = "Supplement"
}

enum ProjectOverrideMemberSetType {
  Primary = "Primary",
  Secondary = "Secondary",
  Alternate = "Alternate",
  Risk = "Risk Analysis",
}

enum AccuracyInspectionIconEnum {
  Ban = "ban",
  Check = "check",
  Question = "question",
  Star = "star",
  Times = "times",
}

enum EntityTypeEnum {
  Unknown = "Unknown",
  Individual = "Individual",
  Facility = "Facility",
}

enum AdequacyRowStatusEnum {
  "Unknown" = "unknown",
  "NoGap" = "noGap",
  "PartialGap" = "partialGap",
  "FullGap" = "fullGap",
  "ApprovedException" = "approvedException",
  "Empty" = "empty",
  "ZeroMembership" = "zeroMembership",
}

enum AccuracyBandEnum {
  Unknown = "Unknown",
  Accurate = "Accurate",
  Suspect = "Suspect",
  Inaccurate = "Inaccurate",
  Skipped = "Skipped",
  Enriched = "Enriched",
}

enum PatientVolumeLabelEnum {
  Unknown = "Unknown",
  Ghost = "Ghost",
  Peripheral = "Peripheral",
  Standard = "Standard",
  Core = "Core",
  InsufficientDataNew = "Insufficient Data - New",
  InsufficientDataStateLOB = "Insufficient Data - State/LOB",
  InsufficientDataSpecialty = "Insufficient Data - Specialty",
  RXOnly = "RX Only",
}

enum AccuracyProviderClaimsActivityLabelEnum {
  Unknown = "Unknown",
  Ghost = "Ghost",
  Peripheral = "Peripheral",
  Standard = "Standard",
  Core = "Core",
  InsufficientDataNew = "Insufficient Data - New",
  InsufficientDataSpecialty = "Insufficient Data - Specialty",
  RXOnly = "RX Only",
}

enum LocationConfidenceScoresLabelEnum {
  Unknown = "Unknown",
  VeryLow = "VeryLow",
  Low = "Low",
  Medium = "Medium",
  High = "High",
}

enum EditPerspective {
  "Edit",
  "Clone"
}

enum ChangedGapsEnum {
  Unknown = "Unknown",
  All = "All",
  Closed = "Closed",
  Opened = "Opened"
}

enum ProviderTerminationType {
  "None",
  "NPI",
  "TIN"
}

enum InputValidationRegExps {
  regexpExcludeAllSpecialCharacters = "^[^()!@#$%^&*/]*$",
  regexpExcludeSpecialCharactersForName = "^[^!@#$^]*$",
  regexpOnlyAllowDigit = "^[0-9]{1}$",
  regexpOnlyAllowDigitsNoLimit = "^(0|[1-9][0-9]*)$",
  regexpOnlyAllowOneDigitOnly1or2= "^[1-2]{1}$",
  regexpOnlyAllow4Digits= "^[0-9]{0,4}$",
  regexpOnlyAllow3DigitsValueLessThanOrEqual100= "^[0-9]$|^[1-9][0-9]$|^(100)$",
  regexpOnlyAllowDigitsLessThanEqual1AndAllowDecimalPlace = "\\^[0-1]|^([0]\\.\\d{0,2})$|^([1]\\.[0])$(.\\d{0,2})$|^(1)$|^(0)$|^1\\.$|^0\\.[0-9][0-9]$",
  regexpOnlyAllowDigitsAndPeriod = "^[0-9\.]*$",
}

enum LocationConfidenceScoreLabelEnum {
  Unknown = "Unknown",
  VeryLow = "Very Low",
  Low = "Low",
  Medium = "Medium",
  High = "High"
}

enum SpecialtyTypeEnum {
  Unknown = "Unknown",
  All = "All",
  Informational = "Informational",
  Required = "Required",
}

enum AffiliationType  {
  ProfessionalAffiliation = "Professional Affiliation",
  InstitutionalAffiliation = "Institutional Affiliation"
}

export {
  AccuracyGapAnalysisStatus,
  AccuracyBandEnum,
  AccuracyInspectionIconEnum,
  AccuracyInspectionResultTypeEnum,
  AccuracyProviderClaimsActivityLabelEnum,
  AccuracySupplementalTypeEnum,
  AdequacyRowStatusEnum,
  AffiliationType,
  ChangedGapsEnum,
  EditPerspective,
  NetworkAssessmentAnalysisType,
  NextClosestProviderAction,
  AdequacyType,
  CalculationMethod,
  ComparisonProviderType,
  EntityTypeEnum,
  ProjectExclusionType,
  FilterType,
  ImpactIndicator,
  NPIStatus,
  PanelStatusEnum,
  ProjectionProviderType,
  ProjectOverrideMemberSetType,
  ProjectPerspective,
  ProjectRunConfigurationStatus,
  ProjectRunConfigurationType,
  ProjectRunConfigurationJobStatus,
  ProviderNetworkType,
  RecommendedActionTypeEnum,
  RegionSetStatusType,
  TimeFrequency,
  TimeDistanceCalculatorType,
  ProjectionProviderHistoryType,
  PatientVolumeLabelEnum,
  LocationConfidenceScoresLabelEnum,
  AttestationRateDays,
  ProjectRunStatusEnum,
  ProviderTerminationType,
  InputValidationRegExps,
  LocationConfidenceScoreLabelEnum,
  SpecialtyTypeEnum
};
